exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select2-selection.select2-selection--single .select2-selection__placeholder{\n  font-size: 15px;\n  color: #b1b7ba;\n}\n.form-control{\ntext-indent: 10px;\n}\n", ""]);

// exports
